module.exports = __webpack_public_path__ + "static/media/42.bb886222.png";